/** InsCoder 2025-02-06 B + Email suggestion for registration form **/
(function () {
  'use strict';

  /**
   * Common email domain list
   * Covers popular providers in Taiwan, China and international
   */
  var COMMON_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'yahoo.com.tw',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'msn.com',
    'live.com',
    'mail.com',
    'aol.com',
    'qq.com',
    '163.com',
    '126.com',
    'me.com',
    'ymail.com',
    'protonmail.com',
    'proton.me',
    'zoho.com',
    'gmx.com',
    'mail.ru',
    'naver.com',
    'seed.net.tw',
    'hinet.net',
    'pchome.com.tw',
    'msa.hinet.net',
    'livemail.tw',
    'kimo.com'
  ];

  /**
   * Calculate the Levenshtein edit distance between two strings
   * @param {string} a
   * @param {string} b
   * @returns {number}
   */
  function levenshteinDistance(a, b) {
    var matrix = [];
    var i, j;

    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    for (i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }
    for (j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    for (i = 1; i <= b.length; i++) {
      for (j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1, // substitution
            matrix[i][j - 1] + 1,       // insertion
            matrix[i - 1][j] + 1         // deletion
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }

  /**
   * Strict email format validation
   * - Local part: no spaces or @
   * - Domain labels: alphanumeric with hyphens
   * - TLD: letters only, at least 2 chars (rejects gmail.com9123)
   * @param {string} email
   * @returns {boolean}
   */
  function isValidEmailFormat(email) {
    var re = /^[^\s@]+@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }

  /**
   * Find the closest matching domain from the common domains list
   * Uses three strategies:
   *   1. Exact match → no suggestion
   *   2. Prefix match → input starts with a known domain + extra chars (e.g. gmail.com9123)
   *   3. Levenshtein distance <= 3 (e.g. gmail.con → gmail.com, gmail.cmmmm → gmail.com)
   * @param {string} inputDomain - The domain entered by the user
   * @returns {string|null} Suggested domain, or null if no match found
   */
  function findClosestDomain(inputDomain) {
    var lowerDomain = inputDomain.toLowerCase();
    var bestMatch = null;
    var bestDistance = Infinity;

    // Exact match found, no suggestion needed
    for (var i = 0; i < COMMON_DOMAINS.length; i++) {
      if (lowerDomain === COMMON_DOMAINS[i]) {
        return null;
      }
    }

    // Strategy 1: Prefix match — input starts with a known domain but has trailing chars
    // e.g. "gmail.com9123" starts with "gmail.com" → suggest "gmail.com"
    for (var k = 0; k < COMMON_DOMAINS.length; k++) {
      if (lowerDomain.length > COMMON_DOMAINS[k].length && lowerDomain.indexOf(COMMON_DOMAINS[k]) === 0) {
        return COMMON_DOMAINS[k];
      }
    }

    // Strategy 2: Known domain is a prefix of input with extra chars appended after TLD
    // e.g. "gmail.coma" — known domain "gmail.com" is contained at the start
    // Already covered by Strategy 1 above

    // Strategy 3: Levenshtein distance <= 3 (covers e.g. gmail.cmmmm → gmail.com)
    for (var j = 0; j < COMMON_DOMAINS.length; j++) {
      var distance = levenshteinDistance(lowerDomain, COMMON_DOMAINS[j]);
      if (distance <= 3 && distance < bestDistance) {
        bestDistance = distance;
        bestMatch = COMMON_DOMAINS[j];
      }
    }

    return bestMatch;
  }

  /**
   * Get email suggestion for the given input
   * @param {string} email - The email entered by the user
   * @returns {string|null} Suggested full email, or null if no match found
   */
  function getEmailSuggestion(email) {
    if (!email || email.indexOf('@') === -1) {
      return null;
    }

    var parts = email.split('@');
    if (parts.length !== 2 || !parts[0] || !parts[1]) {
      return null;
    }

    var localPart = parts[0];
    var domain = parts[1];

    // Domain too short (user still typing), skip suggestion
    if (domain.length < 3) {
      return null;
    }

    var suggestedDomain = findClosestDomain(domain);
    if (suggestedDomain) {
      return localPart + '@' + suggestedDomain;
    }

    return null;
  }

  /**
   * Initialize email suggestion feature
   */
  function initEmailSuggestion() {
    var formsWithHandlers = new WeakSet();
    // Find all email inputs with the suggestion attribute
    var emailInputs = document.querySelectorAll('[data-email-suggestion]');

    emailInputs.forEach(function (input) {
      var suggestionEl = null;
      var wrapper = input.closest('.email-suggestion-wrapper');

      if (!wrapper) return;

      suggestionEl = wrapper.querySelector('.email-suggestion');
      if (!suggestionEl) return;

      var suggestionLink = suggestionEl.querySelector('.email-suggestion__link');
      if (!suggestionLink) return;

      var errorEl = wrapper.querySelector('.email-validation-error');
      var validationMessage = '請輸入有效的電子郵件地址';

      function updateValidationUI(value) {
        if (!errorEl) return;
        if (!value) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
          input.classList.remove('error');
          return;
        }
        if (isValidEmailFormat(value)) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
          input.classList.remove('error');
        } else {
          errorEl.textContent = validationMessage;
          errorEl.classList.add('is-visible');
          input.classList.add('error');
        }
      }

      // Input event: real-time validation + email typo suggestion
      input.addEventListener('input', function () {
        var value = input.value.trim();
        var suggestion = getEmailSuggestion(value);

        if (suggestion) {
          suggestionLink.textContent = suggestion;
          suggestionEl.classList.add('is-visible');
          suggestionEl.setAttribute('aria-hidden', 'false');
        } else {
          suggestionEl.classList.remove('is-visible');
          suggestionEl.setAttribute('aria-hidden', 'true');
        }
        updateValidationUI(value);
      });

      // Click suggestion link: fill the corrected email into the input
      suggestionLink.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = suggestionLink.textContent;
        suggestionEl.classList.remove('is-visible');
        suggestionEl.setAttribute('aria-hidden', 'true');
        updateValidationUI(input.value.trim());
        input.focus();
      });

      // Blur event: delay hide to allow clicking the suggestion first
      input.addEventListener('blur', function () {
        setTimeout(function () {
          suggestionEl.classList.remove('is-visible');
          suggestionEl.setAttribute('aria-hidden', 'true');
        }, 200);
      });

      // Prevent submit when email is invalid (error already shown by real-time validation)
      var form = input.closest('form');
      if (form && !formsWithHandlers.has(form)) {
        formsWithHandlers.add(form);
        form.addEventListener('submit', function (e) {
                  // Validate all email inputs in the form
                  var allEmailInputs = form.querySelectorAll('[data-email-suggestion]');
                  for (var i = 0; i < allEmailInputs.length; i++) {
                    var emailInput = allEmailInputs[i];
                    var value = emailInput.value.trim();
                    if (value && !isValidEmailFormat(value)) {
                      e.preventDefault();
                      // Trigger validation UI update
                      emailInput.dispatchEvent(new Event('input'));
                      emailInput.focus();
                      return;
                    }
            }
        });
      }
    });
  }

  // DOM ready initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmailSuggestion);
  } else {
    initEmailSuggestion();
  }
})();
/** InsCoder 2025-02-06 E + Email suggestion for registration form **/
